module.exports = __webpack_public_path__ + "static/media/redeem-item-img.32d25284.png";